<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';

import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      idInstance: '',
      apiTokenInstance: '',
      apiUrl: 'https://api.green-api.com',
      mediaUrl: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required },
    idInstance: { required },
    apiTokenInstance: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName?.trim(),
            channel: {
              type: 'whatsapp',
              phone_number: this.phoneNumber,
              provider: 'green_api',
              provider_config: {
                id_instance: this.idInstance,
                api_token_instance: this.apiTokenInstance,
                api_url: this.apiUrl,
                ...(this.mediaUrl ? { media_url: this.mediaUrl } : {}),
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
        <input
          v-model="phoneNumber"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.PHONE_NUMBER.PLACEHOLDER')
          "
          @blur="v$.phoneNumber.$touch"
        />
        <span v-if="v$.phoneNumber.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.PHONE_NUMBER.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.idInstance.$error }">
        <span>{{
          $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.ID_INSTANCE.LABEL')
        }}</span>
        <input
          v-model="idInstance"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.ID_INSTANCE.PLACEHOLDER')
          "
          @blur="v$.idInstance.$touch"
        />
        <span v-if="v$.idInstance.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.ID_INSTANCE.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiTokenInstance.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.API_TOKEN_INSTANCE.LABEL') }}
        </span>
        <input
          v-model="apiTokenInstance"
          type="password"
          :placeholder="
            $t(
              'INBOX_MGMT.ADD.WHATSAPP.GREEN_API.API_TOKEN_INSTANCE.PLACEHOLDER'
            )
          "
          @blur="v$.apiTokenInstance.$touch"
        />
        <span v-if="v$.apiTokenInstance.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.API_TOKEN_INSTANCE.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label>
        <span>{{ $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.API_URL.LABEL') }}</span>
        <input
          v-model="apiUrl"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.API_URL.PLACEHOLDER')
          "
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label>
        <span>{{
          $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.MEDIA_URL.LABEL')
        }}</span>
        <input
          v-model="mediaUrl"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.MEDIA_URL.PLACEHOLDER')
          "
        />
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
